import { jsx as _jsx } from "react/jsx-runtime";
import { Check, Copy } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "./cn.js";
import { toast } from "./Toast.js";
export function CopyButton({ value, label = "Copy", className, }) {
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (!copied)
            return;
        const t = setTimeout(() => setCopied(false), 1500);
        return () => clearTimeout(t);
    }, [copied]);
    return (_jsx("button", { type: "button", onClick: async (e) => {
            e.stopPropagation();
            try {
                await navigator.clipboard.writeText(value);
                setCopied(true);
                toast("Copied");
            }
            catch {
                setCopied(false);
            }
        }, className: cn("inline-flex size-11 shrink-0 items-center justify-center rounded-button text-muted transition-colors duration-150 hover:bg-hover hover:text-fg sm:size-9", className), "aria-label": copied ? "Copied" : label, title: copied ? "Copied" : label, children: copied ? (_jsx(Check, { className: "size-4 text-success", "aria-hidden": true })) : (_jsx(Copy, { className: "size-4", "aria-hidden": true })) }));
}
//# sourceMappingURL=CopyButton.js.map